import React from 'react';
import { useFieldHelper } from 'framework/ui/field';
import { Button } from 'framework/ui/mui-builder';
import { useListContext } from 'framework/list';
import { ErrorMessage, useMessageService } from 'framework/ui/Message';
import useOneClickService from 'infrastructure/security/authentication/OneClick/oneClickService';
import useAzureAuthenticator from 'infrastructure/security/authentication/azure/azureAuthenticator';
import { useEventBus, USER_IS_LOGGED_OUT } from 'framework/utils';
import mixpanel from 'infrastructure/integrations/mixpanel';
import { usePostAuthenticationRedirectUrl } from 'infrastructure/security/authentication/postAuthenticationRedirect';

const OneClickButton = ({ password }: { password: { password: Nullable<string> } }) => {
  const { getValue: getUsername } = useFieldHelper({ source: 'username' });
  const { getAccessTokenForUser } = useOneClickService();
  const { addMessage } = useMessageService();
  const { setLoading = () => {} } = useListContext();
  const { authenticate } = useAzureAuthenticator();
  const postAuthenticationRedirectUrl = usePostAuthenticationRedirectUrl();
  const { dispatchEvent } = useEventBus();

  const signInAsUser = (username: string) => {
    setLoading(true);
    getAccessTokenForUser(username, password)
      .then(async ({ accessToken: token, ssid }) => {
        const authToken = { token, ssid };
        dispatchEvent(USER_IS_LOGGED_OUT, {});
        await authenticate(authToken);
        // @ts-ignore
        window.location = postAuthenticationRedirectUrl;

        try {
          mixpanel.identify(username);
          mixpanel.track('Successful_login', {
            email: username,
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn(error);
        }
      })
      .catch(() => {
        addMessage(new ErrorMessage('Cannot sign in as the chosen user'));
        setLoading(false);
      });
  };

  const username = getUsername();
  return (
    <Button
      key={`sign-in-as-${username}`}
      onClick={() => {
        signInAsUser(username);
      }}
    >
      Sign in
    </Button>
  );
};

export default OneClickButton;
